import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import BackButton from '../../Components/BackButton';
import { DashboardLayout } from '../../Layout/DashboardLayout';
import CustomButton from '../../Components/CustomButton';
import { getRequest, patchRequest, postRequest } from '../../Util/requests';
import { errorModal, questionModal, successModal } from '../../Components/CustomModal';
import { AddImageComponent, EditImageComponent } from '../CategoryManagement/ImageComponent';
import CustomLoader from '../../Components/CustomLoader';

const LinkTypeComponentAddEdit = ({ baseAPI }) => {
    const navigate = useNavigate();
    const { id } = useParams();

    const [name, setName] = useState("");
    const [selectedImage, setSelectedImage] = useState(null);
    const [soundImage, setSoundImage] = useState(null);
    const [thumbnail, setThumbnail] = useState('');
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoader(true);
                const response = await getRequest(`${baseAPI}${id}`);
                const data = response.data.data[0];
                if (data) {
                    setName(data.name || "");
                    setThumbnail(data.banner || "");
                    setSelectedImage(data.banner || null);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoader(false);
            }
        };

        if (id) {
            fetchData();
        }
    }, [id, baseAPI]);

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedImage(file);
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                setSoundImage(reader.result);
            };
        } else {
            setSelectedImage(null);
            setSoundImage(null);
        }
    };

    const handleRemoveImage = () => {
        setSoundImage(null);
        setSelectedImage(null);
        setThumbnail(null);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!name) return;

        const result = await questionModal.fire({
            title: `Do you want to ${id ? "Update" : "Add"} this Main category?`,
            confirmButtonText: id ? "Update" : "Add",
        });

        if (result.isConfirmed) {
            setLoader(true);
            try {
                const formData = new FormData();
                formData.append("name", name);
                if (selectedImage instanceof File) {
                    formData.append("banner", selectedImage);
                }

                const response = id
                    ? await patchRequest(`${baseAPI}${id}/`, formData, "multipart/form-data")
                    : await postRequest(`${baseAPI}`, formData, "multipart/form-data");

                if (response && response.status !== 500) {
                    successModal.fire({
                        text: `Main category ${id ? "Updated" : "Added"} Successfully`,
                        confirmButtonText: "Continue",
                    });
                    navigate("/scofa/main-categories");
                } else {
                    throw new Error("Server returned 500");
                }
            } catch (error) {
                console.error("Submission error:", error);
                errorModal.fire({
                    text: `Main category ${id ? "Updated" : "Added"} Failed`,
                    confirmButtonText: "Continue",
                });
            } finally {
                setLoader(false);
            }
        }
    };
    if (loader) {
        return <CustomLoader />
    }
    return (
        <DashboardLayout>
            <div className="container-fluid">
                <div className="row mb-3">
                    <div className="col-12 mb-2">
                        <h2 className="mainTitle">
                            <BackButton />
                            {id ? `Edit ` : `Add `}Main category
                        </h2>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-12">
                        <div className="row mb-5">
                            <div className="col-lg-6 mb-2">
                                <div className="inputWrapper">
                                    <label className="mainLabel">Main category*</label>
                                    <div className="d-flex align-items-center gap-2">
                                        <input
                                            type="text"
                                            placeholder="Enter Main category"
                                            className="mainInput"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                            {id ? (
                                <EditImageComponent
                                    thumbnail={thumbnail}
                                    handleImageChange={handleImageChange}
                                    soundImage={soundImage}
                                    handleRemoveImage={handleRemoveImage}
                                />
                            ) : (
                                <AddImageComponent
                                    soundImage={soundImage}
                                    handleImageChange={handleImageChange}
                                    handleRemoveImage={handleRemoveImage}
                                />
                            )}
                        </div>
                        <div className="row mb-3">
                            <div className="col-12">
                                <CustomButton
                                    variant="primaryButton"
                                    text={id ? "Update" : "Add"}
                                    onClick={handleSubmit}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </DashboardLayout>
    );
};

export default LinkTypeComponentAddEdit;